export const en = {
  profile: {
    pageTitle: 'Profile',
    teamList: {
      goTo: 'See all teams ({{count}})',
      manager: 'Manager',
      noTeamName: 'Unnamed',
      viewDetails: 'View',
    },
  },
};
